import React from "react";
import SiteShell from "../components/SiteShell";

export default function ReservationPolicy() {
  return (
    <SiteShell>
      <section style={{ maxWidth: 780, margin: "0 auto",
        padding: "clamp(56px, 8vw, 100px) clamp(20px, 5vw, 60px)" }} data-testid="reservation-policy-page">
        <div className="gg-eyebrow" style={{ marginBottom: 10 }}>Reservation policy</div>
        <h1 className="gg-h1" style={{ marginBottom: 18 }}>Under review with counsel.</h1>
        <p style={{ color: "var(--text-dim)", fontSize: 16.5, lineHeight: 1.7 }}>
          The final Sovereign Block reservation policy — refund terms, transfer
          rules, and cooperative bylaws — is being finalised with legal counsel
          and will be published here before Sovereign Blocks go on general sale.
          In the interim, all Phase-5 reservations are made under the interim
          understanding that the fee is fully refundable if the community
          project does not reach anchor threshold.
        </p>
      </section>
    </SiteShell>
  );
}
